var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTwitterx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "r-13v1u17 r-4qtqp9 r-yyyyoo r-16y2uox r-8kz0gk r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-lrsllp",
    width: 13.988,
    height: 14,
    "aria-hidden": "true",
    viewBox: "0 0 13.988 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter27144",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color1",
    type: "hueRotate",
    values: 180
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0.21 0.72 0.07 0.915888 0 "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.47971 0 0 .47971 1.249 1.25)",
    filter: "url(#filter27144)",
    strokeWidth: 1.0003
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.258 10.152 8.918-10.152h-2.113l-7.747 8.813-6.183-8.813h-7.133l9.352 13.328-9.352 10.645h2.113l8.176-9.309 6.531 9.309h7.133z",
    strokeWidth: 1.0003
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTwitterx);
export default __webpack_public_path__ + "static/media/icn-twitterx.ddbe5995db65794d88da94ecd7060a24.svg";
export { ForwardRef as ReactComponent };